module.exports = __webpack_public_path__ + "static/img/6.6483a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/6.png
// module id = z4NX
// module chunks = 0